module.exports = __webpack_public_path__ + "img/menu.d6ad4013.svg";